import { effect, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SkinningLib, ColorScheme } from '@gridscale/gs-services/skinning.lib';


@Injectable({
  providedIn: 'root'
})
export class SkinningService extends SkinningLib {
  colorScheme = signal<ColorScheme>('browser');
  styleProperties = toSignal(this.styleProperties$);
  isGreylabel = toSignal(this.isGreylabel$);
  stylePropertiesLightmode = toSignal(this.stylePropertiesLightmode$);
  darkModeColorHsl = toSignal(this.darkModeColorHsl$);
  primaryColorHsl = toSignal(this.primaryColorHsl$);
  darkMode = toSignal(this.darkMode$);

  constructor() {
    super();

    effect(() => {
      const colorScheme = this.colorScheme();
      this.colorScheme$.next(colorScheme);
    }, { allowSignalWrites: true });

    this.colorScheme$.subscribe(colorScheme => {
      this.colorScheme.set(colorScheme);
    })
  }

}
